import { Component, OnInit, Renderer } from '@angular/core';
import { Router } from '@angular/router';

import { MetaService } from '@ngx-meta/core';
import { GoogleAnalyticsService } from './addon/ga.service';
import { NotifyService } from './addon/notify.service';
import { AppServices } from './app.services';

declare var $:any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
	constructor(private meta: MetaService, private router: Router, private appServices: AppServices, private notifyServices: NotifyService
		, private renderer: Renderer, private gaService: GoogleAnalyticsService) {
		router.events.subscribe((event:any) => {
			if (event.constructor.name === 'NavigationStart') {
			}
			if (event.constructor.name === 'NavigationEnd') {
				gaService.emitPage(event.urlAfterRedirects);
				$('input[type="text"], textarea').on('focus', function() {
					$(this).parent().addClass('active');
					$(this).parent().removeClass('no-shadow');
				}).on('blur', function() {
					if ($(this).val().trim() == '') {
						$(this).parent().removeClass('active');
						$(this).parent().removeClass('no-shadow');
					}
					else {
						$(this).parent().addClass('no-shadow');
					}
				});
			}
		});
	}

	ngOnInit() {
		this.appServices.api('Configs/find', {
			'filter': `{}`
		}, this).then(function(obj){
			let res = obj.response.json().res;
			obj.component.meta.setTitle(res.filter(function(v){
				return v.name == 'site_name';
			})[0].val);
			obj.component.meta.setTag('description', res.filter(function(v){
				return v.name == 'meta_description';
			})[0].val);
			obj.component.meta.setTag('og:description', res.filter(function(v){
				return v.name == 'meta_description';
			})[0].val);
			obj.component.meta.setTag('og:image', res.filter(function(v){
				return v.name == 'meta_image';
			})[0].val);
		}).catch(function(err){
			err.component.notifyServices.show(err.err.json().error.message, 'danger');
		})
		let path = window.location.href;
		if (path && path.length > 0) {
			let splash1 = path.substr(path.indexOf('/') + 2);
			let splash2 = splash1.substr(splash1.indexOf('/') + 1);
			if(splash2) {
				this.router.navigate([splash2]);
			} else {
				this.router.navigate(['main/home']);
			}
		} else {
			this.router.navigate(['main/home']);
		}
		/*
		let path = window.location.hash;
		if (path && path.length > 0) {
			if(path.substr(2)) {
				this.router.navigate([path.substr(2)]);
			} else {
				this.router.navigate(['main/home']);
			}
		} else {
			this.router.navigate(['main/home']);
		}
		*/
	}
	onDeactivate() {
		this.renderer.setElementProperty(document.body, 'scrollTop', 1000);
	}
}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/app.component.ts